module.exports = __webpack_public_path__ + "static/media/comments-alt.dae68b39.svg";